import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBatteryError: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="battery-error, power"><path d="M12.5 10L10.5 12M10.5 12L8.5 14M10.5 12L8.5 10M10.5 12L12.5 14M1.75 5.75H19.25V18.25H1.75V5.75ZM19.25 8.75H22.25V15.25H19.25V8.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBatteryError;
